export const felineTests = [
  { id: '2666', description: 'Feline Cardiopet® proBNP Test' },
  { id: '2627', description: 'Feline Comprehensive Diarrhea RealPCR™ Panel' },
  {
    id: '2512',
    description: 'Feline Upper Respiratory Disease (URD) RealPCR™ Panel',
  },
  { id: '2493', description: 'Spec fPL® Test' },
];
